const gray = {
  $50: '#FCFCFC',
  $100: '#FAFAFA',
  $200: '#F5F5F5',
  $230: '#F0F0F0',
  $260: '#EBEBEB',
  $300: '#E8E8E8',
  // border, divider
  $400: '#E0E0E0',
  $470: '#CCCCCC',
  $500: '#C0C0C0',
  $550: '#ABABAB',
  // guide text
  $600: '#959595',
  $700: '#707070',
  $800: '#5c5c5c',
  // main black
  $900: '#333333',
} as const

const blue = {
  $50: '#f0fdf4',
  $100: '#dcfce7',
  $200: '#bbf7d0',
  $300: '#22C55E',
  $350: '#22c55e',
  $400: '#16a34a',
  $500: '#22c55e',
} as const

const studentApp = {
  blue: {
    $50: '#dcfce7',
    $500: '#16a34a',
  },
  studentBG: '#F0F2F4',
  green: {
    $100: '#2B6589',
    $600: '#8ED5BD',
    $700: '#E1F5EE',
  },
} as const

const red = {
  $100: '#FFEBEE',
  $150: '#FFA3AC',
  $200: '#FFCDD2',
  $230: '#FFE0E5',
  $300: '#FF707D',
  $320: '#FF6674',
  $400: '#fd5354',
} as const

const orange = {
  $100: '#F5AA0C',
  $200: '#FA8632',
  $300: '#FF5700',
} as const

const yellow = {
  $100: '#ffc64d',
  $200: '#FFB930',
  $300: '#AE883A',
}
const green = {
  $100: '#54c0b1',
}
// const green = '#54c0b1'
const deepGreen = '#57bf9c'
const positive = '#00C853'
const negative = red.$400
const overlay = 'rgba(0, 0, 0, 0.5)'
const primary = 'var(--Colors-Green-500)'
const borderColor = gray.$400
const guide = gray.$700
const rowHoverColor = gray.$100
const textButtonHoverColor = '#8A8A8A'
const inputHoverColor = '#CCCCCC'
const wheat = '#fdf0c8'
const purple = '#6050bd'
const grayHover = gray.$260
const subgreen = '#54c0b1'
const subPurple = '#767DE8'
const subYellow = '#FFB155'

const colors = {
  rowHoverColor,
  textButtonHoverColor,
  inputHoverColor,
  grayHover,
  positive,
  negative,
  overlay,
  primary,
  borderColor,
  guide,
  gray,
  red,
  orange,
  blue,
  yellow,
  green,
  deepGreen,
  wheat,
  purple,
  subPurple,
  subgreen,
  subYellow,
  studentApp,
}

export default colors

const grayInHSL = {
  $50: { h: 0, s: 0, l: 99 },
  $100: { h: 0, s: 0, l: 98 },
  $200: { h: 0, s: 0, l: 96 },
  $230: { h: 0, s: 0, l: 94 },
  $260: { h: 0, s: 0, l: 92 },
  $300: { h: 0, s: 0, l: 91 },
  $400: { h: 0, s: 0, l: 88 },
  $470: { h: 0, s: 0, l: 80 },
  $500: { h: 0, s: 0, l: 75 },
  $550: { h: 0, s: 0, l: 67 },
  $600: { h: 0, s: 0, l: 58 },
  $700: { h: 0, s: 0, l: 44 },
  $800: { h: 0, s: 0, l: 36 },
  $900: { h: 0, s: 0, l: 20 },
}

const blueInHSL = {
  $50: { h: 138, s: 76, l: 97 },
  $100: { h: 141, s: 84, l: 93 },
  $200: { h: 141, s: 79, l: 85 },
  $300: { h: 142, s: 71, l: 45 },
  $350: { h: 142, s: 71, l: 45 },
  $400: { h: 142, s: 76, l: 36 },
  $500: { h: 142, s: 71, l: 45 },
}

const redInHSL = {
  $100: { h: 351, s: 100, l: 96 },
  $150: { h: 354, s: 100, l: 82 },
  $200: { h: 354, s: 100, l: 90 },
  $230: { h: 350, s: 100, l: 94 },
  $300: { h: 355, s: 100, l: 72 },
  $320: { h: 355, s: 100, l: 70 },
  $400: { h: 360, s: 98, l: 66 },
}

const orangeInHSL = {
  $100: { h: 41, s: 92, l: 50 },
  $200: { h: 25, s: 95, l: 59 },
  $300: { h: 20, s: 100, l: 50 },
}
const yellowInHSL = {
  $100: { h: 41, s: 100, l: 65 },
  $200: { h: 40, s: 100, l: 59 },
  $300: { h: 40, s: 50, l: 45 },
}
const greenInHSL = {
  $100: { h: 141, s: 84, l: 93 },
  $200: { h: 141, s: 79, l: 85 },
  $300: { h: 142, s: 71, l: 45 },
}

const deepGreenInHSL = { h: 160, s: 45, l: 55 }

const positiveInHSL = { h: 145, s: 100, l: 39 }
const negativeInHSL = redInHSL.$400
const overlayInHSL = { h: 0, s: 0, l: 0, a: 0.5 }
const primaryInHSL = greenInHSL.$300
const borderColorInHSL = grayInHSL.$400
const guideInHSL = grayInHSL.$700
const rowHoverColorInHSL = grayInHSL.$100
const textButtonHoverColorInHSL = { h: 0, s: 0, l: 54 }
const inputHoverColorInHSL = grayInHSL.$470
const wheatInHSL = { h: 45, s: 93, l: 89 }
const purpleInHSL = { h: 249, s: 45, l: 53 }
const grayHoverInHSL = grayInHSL.$260
const subgreenInHSL = greenInHSL.$100
const subPurpleInHSL = { h: 236, s: 71, l: 69 }

export const HSLColors = {
  rowHoverColor: rowHoverColorInHSL,
  textButtonHoverColor: textButtonHoverColorInHSL,
  inputHoverColor: inputHoverColorInHSL,
  grayHover: grayHoverInHSL,
  positive: positiveInHSL,
  negative: negativeInHSL,
  overlay: overlayInHSL,
  primary: primaryInHSL,
  borderColor: borderColorInHSL,
  guide: guideInHSL,
  gray: grayInHSL,
  red: redInHSL,
  orange: orangeInHSL,
  blue: blueInHSL,
  yellow: yellowInHSL,
  green: greenInHSL,
  deepGreen: deepGreenInHSL,
  wheat: wheatInHSL,
  purple: purpleInHSL,
  subPurple: subPurpleInHSL,
  subgreen: subgreenInHSL,
}
